import React, {forwardRef, memo} from "react";
import useLoader from './useLoader';
import {global} from "./preset";

const withRemoteLoader = (WrappedComponent) => {
    const RemoteComponent = forwardRef(({
                                            modules = [],
                                            remoteError,
                                            onLoadComplete,
                                            remoteFallback,
                                            remoteOptions,
                                            ...props
                                        }, ref) => {
        const {loading, error, remoteModules} = useLoader({modules, onLoadComplete, options: remoteOptions});

        if (loading) {
            return remoteFallback ?? global.fallback;
        }

        if (error) {
            const finalError = remoteError ?? global.error;
            return typeof finalError === 'function' ? finalError(error) : finalError;
        }

        return <WrappedComponent {...props} ref={ref} remoteModules={remoteModules}/>;
    });
    RemoteComponent.displayName = `withRemoteLoader(${WrappedComponent.displayName || WrappedComponent.name})`;
    return memo(RemoteComponent);
};

export const createWithRemoteLoader = (params) => (WrappedComponent) => {
    const RemoteComponent = withRemoteLoader(WrappedComponent);
    const CreateWithRemoteLoaderComponent = memo(forwardRef((props, ref) => {
        const mergedProps = Object.assign({}, params, props);
        return <RemoteComponent {...mergedProps} ref={ref}/>;
    }));
    CreateWithRemoteLoaderComponent.displayName = `createWithRemoteLoader(${WrappedComponent.displayName || WrappedComponent.name})`;
    return CreateWithRemoteLoaderComponent;
};

export default withRemoteLoader;
